import appConfig from '@/config/applicationConfig.js'

export const InventoryServiceMixim = {
  methods: {

    /**
    * Update the given sku inventory
    * @param sku
    * @param newInventory
    */
    updateInventory (skuId, totalQuantity, reservedQuantity) {
      let payload = {
        'totalQuantity': totalQuantity,
        'reservedQuantity': reservedQuantity
      }
      return this.$http.put(
        `${appConfig.API_END_POINT}/sku/inventories/${skuId}`, payload,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.access_token}`
          }
        }
      )
    },

    /**
    * Gte the inventory csv content file
    */
    getInventoryCSV (filters) {
      let url = new URL(`${appConfig.API_END_POINT}/sku/inventories/downloadcsv`)
      let params = {}

      params.accountName = filters.account || null
      params.fromSkuId = filters.sku?.desde || null
      params.toSkuId = filters.sku?.hasta || null
      params.fromUpc = filters.upc?.desde || null
      params.toUpc = filters.upc?.hasta || null
      params.categoryId = filters.category?.id || null
      params.fromQuantity = filters.fromQuantity || null
      params.toQuantity = filters.toQuantity || null
      params.fromDate = filters.fecha?.desde || null
      params.toDate = filters.fecha?.hasta || null

      Object.keys(params).forEach(
        (key) => {
          if (params[key] !== null) {
            url.searchParams.append(key, params[key])
          }
        }
      )

      return this.$http.get(
        url.href,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.access_token}`,
            Accept: 'application/octet-stream; charset=ISO-8859-1'
          },
          responseType: 'arraybuffer'
        }
      )
    },

    /**
    * Add inventory
    * @param inventory
    */
    addInventoryCSV (csvInventoryFile, delimiter) {
      let formData = new FormData()
      formData.append('file', csvInventoryFile)
      return this.$http.post(`${appConfig.API_END_POINT}/sku/inventories/importcsv?delimiter=${delimiter}`, formData,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.access_token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      )
    }
  }
}
